import { useQuery } from '@tanstack/react-query'

import { useAuthInfo } from '@sweetauth/core'

import { API_URL } from '@/constants/env'

import type { User } from '@/types/User'

const fetchUser = async (
  accessToken: string | undefined | null,
): Promise<User | undefined> => {
  if (accessToken === undefined || accessToken === null) {
    return
  }
  const res: Response = await fetch(`${API_URL}/api/v1/user/`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  })
  if (!res.ok) {
    throw new Error(res.statusText)
  }
  return res.json()
}

export const useSelf = () => {
  // TODO: i'm not really a big fan of how this is set up, but for now it's the only way i can think
  // of for getting auth set up on a per page basis so that we can expose some pages to SEO without auth
  const { accessToken, user } = useAuthInfo()
  return useQuery({
    // DO NOT GET RID OF THE USER KEY, IT'S WHAT ALLOWS UNAUTHENTICATED SSR TO WORK
    // TODO: FIGURE OUT A BETTER WAY TO DO THIS, LIKELY NEED TO REACH OUT TO PROPELAUTH
    queryKey: ['self', user?.userId],
    queryFn: async (): Promise<User> => {
      const dbUser = await fetchUser(accessToken)
      if (dbUser === undefined) {
        return {
          id: 'guest',
          created_at: new Date(),
          last_modified: new Date(),
          first_name: 'Guest',
          last_name: '',
          picture_url: undefined,
          email: '',
        }
      }
      return dbUser
    },
    staleTime: 10 * 60 * 1000, // 10 minutes
    refetchOnMount: false,
  })
}
